import React from 'react';

// utils
import { UserContext } from '@zola-helpers/client/dist/es/@types';
import { renderMobileRichTextAsHtml } from 'libs/contentful/staticContent/richText';

// Components
import H from '@zola/zola-ui/src/typography/Headings';
import { StaticContent } from 'libs/contentful/staticContent/types';
import StaticContentPageContainer from 'components/StaticContent/StaticContentPageContainer';
import {
  Container,
  TitleContainer,
  BodyContainer,
} from 'components/StaticContent/StaticContentPage.styles';
import Head from 'next/head';

type StaticContentProps = {
  navHTML: string;
  userCtx: UserContext;
  staticContent: StaticContent;
};

const StaticContentPage: React.FC<StaticContentProps> = ({ navHTML, userCtx, staticContent }) => {
  const { title, body, slug } = staticContent;
  const isGuest = userCtx ? Boolean(userCtx.is_guest) : true;

  return (
    <StaticContentPageContainer navHTML={navHTML} userCtx={userCtx} inApp>
      <Head>
        <title>{title} - Zola</title>
        <link rel="canonical" href={`https://www.zola.com/mobile/${slug}`} />
        <meta
          property="og:image"
          content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-heart-marine.png"
        />
      </Head>
      <Container isGuest={isGuest}>
        <TitleContainer>
          <H.TitleMedium1 presentation="h3">{title}</H.TitleMedium1>
        </TitleContainer>
        <BodyContainer>{renderMobileRichTextAsHtml(body)}</BodyContainer>
      </Container>
    </StaticContentPageContainer>
  );
};

export default StaticContentPage;
